import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { RegistrationProvider } from "@/context/RegistrationContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import RegisterFlow from "@/pages/RegisterFlow";
import Success from "@/pages/Success";
import CandidateDashboard from "@/pages/CandidateDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminApplications from "@/pages/AdminApplications";
import AdminRegistrations from "@/pages/AdminRegistrations";
import AdminApplicationDetail from "@/pages/AdminApplicationDetail";
import AdminFinance from "@/pages/AdminFinance";
import AdminCheckin from "@/pages/AdminCheckin";
import AdminLogin from "@/pages/AdminLogin";
import SlotDisplay from "@/pages/SlotDisplay";
import { AdminGuard } from "@/components/AdminGuard";
import { AdminAuthProvider } from "@/lib/adminAuth";
import { AppNoSync } from "@/components/AppNoSync";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
      <RegistrationProvider>
        <BrowserRouter>
          <AppNoSync />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/otp" element={<Navigate to="/" replace />} />
            <Route path="/register" element={<RegisterFlow />} />
            <Route path="/success" element={<Success />} />
            <Route path="/dashboard" element={<CandidateDashboard />} />
            <Route path="/dashboard/*" element={<CandidateDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
            <Route path="/admin/applications" element={<AdminGuard><AdminApplications /></AdminGuard>} />
            <Route path="/admin/registrations" element={<AdminGuard><AdminRegistrations /></AdminGuard>} />
            <Route path="/admin/registrations/:id" element={<AdminGuard><AdminApplicationDetail /></AdminGuard>} />
            <Route path="/admin/finance" element={<AdminGuard><AdminFinance /></AdminGuard>} />
            <Route path="/admin/checkin" element={<AdminGuard><AdminCheckin /></AdminGuard>} />
            <Route path="/admin/policies" element={<Navigate to="/admin" replace />} />
            <Route path="/display" element={<SlotDisplay />} />
            <Route path="/tv" element={<SlotDisplay />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              fontFamily: "Plus Jakarta Sans, sans-serif",
            },
          }}
        />
      </RegistrationProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
